import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiRadio } = FiIcons;

const joeMooreImg = "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/9dd17fec1fdcb7fd672605344380884e.jpg";
const katrenaImg = "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=150&h=150";

const LivestreamCompactBanner = () => {
  return (
    <div className="w-full bg-[#0A1128] border-b-2 border-[#00E5FF]/40 shadow-lg shadow-[#00E5FF]/5 font-sans">
      {/* Responsive container: 
        - Mobile: Stacked (flex-col) 
        - Desktop: Single line (md:flex-row)
        - py-2.5 keeps it THIN
      */}
      <div className="max-w-[1400px] mx-auto px-4 py-2.5 flex flex-col md:flex-row items-center justify-between gap-4">
        
        {/* 1. BRAND & STATUS */}
        <div className="flex items-center gap-3 shrink-0">
          <div className="flex items-center justify-center">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00E5FF] opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#00E5FF]"></span>
            </span>
          </div>
          <div className="flex flex-col text-center md:text-left">
            <h2 className="text-white font-black uppercase text-sm md:text-base tracking-widest leading-none m-0">
              AI Safety Summit
            </h2>
            <span className="text-[#00E5FF] text-[0.65rem] font-bold uppercase tracking-widest mt-1 leading-none">
              April 8 • Live Stream
            </span>
          </div>
        </div>

        {/* 2. THE HOSTS & INFO (Ultra-Compact) */}
        <div className="flex items-center gap-3 bg-[#060c1a] px-4 py-1.5 rounded-full border border-white/10 shrink-0">
          <div className="flex -space-x-2">
            <img src={joeMooreImg} alt="Joe Moore" className="w-7 h-7 rounded-full border-2 border-[#060c1a] object-cover object-top" />
            <img src={katrenaImg} alt="Katrena Drake" className="w-7 h-7 rounded-full border-2 border-[#060c1a] object-cover" />
          </div>
          <div className="flex flex-col">
            <span className="text-gray-300 text-xs font-semibold leading-tight">
              Hosted by <span className="text-white font-bold">Joe & Katrena</span>
            </span>
            <span className="text-gray-500 text-[0.6rem] uppercase tracking-widest leading-tight">
              + 3 Expert Keynotes
            </span>
          </div>
        </div>

        {/* 3. CTA BUTTONS */}
        <div className="flex items-center gap-2 w-full md:w-auto">
          <a
            href="https://territory.digitalcowboy.io/en/event/ai-safetytm-summit-the-live-stream-series/5878/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 md:flex-none bg-[#00E5FF] hover:bg-white text-[#0A1128] text-xs font-black py-2.5 px-6 rounded flex items-center justify-center transition-colors uppercase tracking-widest whitespace-nowrap focus:outline-none"
          >
            Register
          </a>
          <a
            href="https://territory.digitalcowboy.io/live-details/ai-safety-summit-the-live-stream-series/1465/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 md:flex-none border border-[#00E5FF]/40 hover:border-[#00E5FF] text-gray-300 hover:text-[#00E5FF] text-xs font-bold py-2.5 px-4 rounded flex items-center justify-center transition-colors uppercase tracking-widest whitespace-nowrap focus:outline-none"
          >
            <SafeIcon icon={FiRadio} className="w-4 h-4 mr-2" />
            Live Room
          </a>
        </div>

      </div>
    </div>
  );
};

export default LivestreamCompactBanner;